import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Country, CustomerDetails, ShippingAddress } from '../../interfaces';
import { HARDCOPY_COUNTRIES, HARDCOPY_DEFAULT_COUNTRY } from '../../settings';
import { formatPrice } from '../../tools';
import { HardcopyOrderTotalPage } from '../order-total/order-total';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';

@Component({
    selector: 'page-hardcopy-postage-cost',
    templateUrl: 'postage-cost.html'
})

export class HardcopyPostageCostPage {

    public countries = HARDCOPY_COUNTRIES;
    public customerDetails: CustomerDetails = null;
    public qty: number = 1;
    public shippingAddress: ShippingAddress = null;

    public get country(): Country {
        let _default = null;
        for (let country of this.countries) {
            if (country.id == HARDCOPY_DEFAULT_COUNTRY) _default = country;
            if (country.id == this.shippingAddress.country) return country;
        }
        return _default;
    }

    public set country(country: Country) {
        this.shippingAddress.country = country.id;
    }

    constructor(
        public analytics: FirebaseAnalytics,
        public navCtrl: NavController,
        public navParams: NavParams,
    ) {
        this.customerDetails = navParams.get('customerDetails');
        this.shippingAddress = navParams.get('shippingAddress');
        this.qty = navParams.get('qty');
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('HardcopyPostageCost');
        this.analytics.logEvent('checkout_progress', {
            checkout_step: 4
        });
    }

    public getPostageCost() {
        return formatPrice(this.qty * this.country.postage);
    }

    public next() {
        this.navCtrl.push(HardcopyOrderTotalPage, {
            customerDetails: this.customerDetails,
            qty: this.qty,
            shippingAddress: this.shippingAddress,
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/pages/postage-cost/postage-cost.ts